import './styles/PrivacyPolicy.css';

const PrivacyPolicy = ({ onBack }) => {
    return (
        <div className="privacy-policy-page">
            <div className="privacy-policy-header">
                {onBack && (
                    <button className="privacy-policy-back" onClick={onBack} type="button">
                        Back to game
                    </button>
                )}
            </div>

            <div className="privacy-policy-card">
                <h1>Privacy Policy</h1>

                <p>
                    This Privacy Policy explains the limited information collected by The Combos.
                    The game does not collect personal information such as names, email addresses,
                    phone numbers, or account details. We only collect gameplay data and analytics data
                    needed to improve the game and understand usage.
                </p>

                <h2>What We Collect</h2>
                <p>We collect only non-personal gameplay data and usage analytics, including:</p>

                <h3>Game Data</h3>
                <ul>
                    <li>scores, completion times, and game results</li>
                    <li>board numbers, game mode, and puzzle-related activity</li>
                    <li>timestamps for gameplay sessions</li>
                    <li>aggregate gameplay statistics used to improve balance and features</li>
                </ul>

                <h3>Google Analytics Data</h3>
                <p>
                    We use Google Analytics to understand how people use the app. This may include
                    device and browser information, session data, interaction events, app usage
                    patterns, and approximate location data. Google may also process technical data
                    such as IP address in accordance with its own privacy practices.
                </p>

                <h2>What We Do Not Collect</h2>
                <p>
                    The Combos does not collect personal information such as your name, email,
                    mailing address, payment details, or social media account information.
                    We do not require you to create an account to play.
                </p>

                <h2>How We Use This Information</h2>
                <p>We use this information to:</p>
                <ul>
                    <li>improve gameplay and game balance</li>
                    <li>understand how users interact with the app</li>
                    <li>measure engagement and app performance</li>
                    <li>fix bugs and make the experience better</li>
                </ul>

                <h2>Sharing of Information</h2>
                <p>We may share limited data with Google Analytics and other service providers that support the app.</p>
                <p>We do not sell personal information. We do not collect personal information for sale or advertising purposes.</p>

                <h2>Cookies and Tracking Technologies</h2>
                <p>
                    Our app may use cookies, analytics tags, and similar technologies to collect usage
                    data and improve performance. These tools help us understand how the app is used.
                </p>

                <h2>Data Retention</h2>
                <p>
                    We keep gameplay and analytics data only as long as necessary for app operation,
                    product improvement, and legal or technical requirements.
                </p>

                <h2>Children’s Privacy</h2>
                <p>
                    We do not intentionally collect personal information from children under 13.
                    The game is designed for general gameplay use and does not require personal account data.
                </p>

                <h2>Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Continued use of the app after
                    any changes are posted means you accept the revised policy.
                </p>

                <h2>Contact Information</h2>
                <p>If you have questions about this Privacy Policy, please contact:</p>
                <p>
                    The Combos<br />
                    thecombosapp@gmail.com<br />
                    https://thecombos.app
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
